export default "__VITE_ASSET__B6Zho0Tl__"